import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook global de status de acesso (trial + assinatura).
 * Faz polling leve a cada 60s para detectar expiração em tempo real.
 */
export function useAccessStatus() {
  const [state, setState] = useState({
    loading: true,
    hasAccess: true,
    reason: null,
    trialActive: false,
    trialDaysLeft: 0,
    trialExpiresAt: null,
    hasSubscription: false,
    subscriptionStatus: null,
  });

  const fetchStatus = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/me/access-status`);
      setState({
        loading: false,
        hasAccess: !!res.data.has_access,
        reason: res.data.reason || null,
        trialActive: !!res.data.trial_active,
        trialDaysLeft: res.data.trial_days_left ?? 0,
        trialExpiresAt: res.data.trial_expires_at || null,
        hasSubscription: !!res.data.has_subscription,
        subscriptionStatus: res.data.subscription_status || null,
      });
    } catch {
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    const id = setInterval(fetchStatus, 60_000);
    return () => clearInterval(id);
  }, [fetchStatus]);

  return { ...state, refetch: fetchStatus };
}
